var map = {
	"./art-security.jpg": "7746",
	"./banner.jpg": "301c",
	"./custom-solutions-2.jpg": "b243",
	"./custom-solutions.jpg": "af17",
	"./davarj-profile.jpg": "90f5",
	"./framing-consultation.jpg": "a8ba",
	"./image-bg-5.jpg": "a511",
	"./picture-hanging.jpg": "bd67",
	"./reclaimed-materials.jpg": "057d",
	"./sculpture-installation.jpg": "4996"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";